var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./MailList.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cd40c922\",\"hasScoped\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./MailList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/MailList.vue
// module id = 404
// module chunks = 0